import { TawkLiveChat } from "tawk-react";

import config from "../Config";

export const TawkTo = () => {
	const { TAWK_TO_KEY } = config;

	return <TawkLiveChat propertyId={TAWK_TO_KEY} widgetId="default" />;
};
